export const AppNames = {
  Summary: "WAEG"
};
//use DAEG for now, will discuss and set it to waeg or waeg-summary later.
